import { OutlineWarning01Icon } from '@tempmee/react-icons';
import { colors } from '@tempmee/tailwind';
import ConfirmPopup from '../../shared/ConfirmPopup';

/**
 * Blocks confirm/decline until the office adds a payment method.
 */
export const PaymentMissingPopup = ({ onGoBack, onAddPayment }) => (
  <ConfirmPopup
    Icon={() => (
      <div style={{ marginBottom: 20 }}>
        <OutlineWarning01Icon size={64} color={colors.warning[500]} />
      </div>
    )}
    title="Payment Method Missing"
    description='Please add your preferred payment method to "Confirm" or "Decline" a candidate.'
    descriptionStyle={{ width: '76%', marginBottom: 50 }}
    leftButtonText="Go Back"
    leftButtonAction={onGoBack}
    rightButtonText="Add Payment"
    rightButtonAction={onAddPayment}
  />
);
